export var defaults = {
  login: {
    title: 'Sign in',
    subTitle: 'to your Chegg account',
    loginSubmitButtonTitle: 'Sign in',
    invalidEmailError: 'Hmm... this doesn’t look right.',
    emptyEmailError: 'Email can not be empty.',
    emailInputLabel: 'Email',
    emailPlaceHolder: 'Enter your email',
    passwordInputLabel: 'Password',
    passwordInputPlaceHolder: 'Enter your password',
    dontHaveAccount: "Don't have an account?",
    noCheggAccountText: 'This account does not exist at Chegg. Sign in with your email and password or',
    createAnAccountText: 'Create an account',
    passwordForceResetError: 'Welcome back! You need to ',
    passwordForceResetLinkError: 'reset your password',
    passwordForceResetTwoError: ' to sign in. ',
    passwordForceResetLearnMoreLinkError: 'Learn more.',
    noMatchError: 'Email and password don’t match.',
    emailError: 'Email is invalid. Please check your email address.',
    genericError: "It's not you, it’s us. Please try again later.",
    createAccountLabel: 'Create an account',
    noCheggAccountError: 'This account does not exist at Chegg. Sign in with your email and password or',
    footerSignupText: 'Sign up',
    footerForgotPasswordText: 'Forgot Password?',
    mergedClientCredentialsUsedError: 'We joined Chegg & Mathway worlds into one shiny account. Use Chegg password to sign in'
  },
  signup: {
    title: 'Create an account',
    buttonTitle: 'Create account',
    identityTitle: 'Are you a',
    schoolTypeTitle: 'Studying in',
    highSchoolYearSelectTitle: 'You plan to graduate in',
    collegeSelectTitle: 'Attending',
    collegeNamePlaceHolder: 'Enter your college name',
    collegeYearSelectionTitle: 'Year',
    invalidEmailError: 'Hmm... this doesn’t look right.',
    emptyEmailError: 'Email can not be empty.',
    agreeToTermsAndPrivacyText: 'We respect your privacy. by clicking Create account you agree to the',
    legalTermsLinkText: 'Terms of use',
    andText: 'and',
    privacyPolicyLinkText: 'Privacy Policy',
    bottomFooterText: 'Already have an account?',
    flipToSigninButtonText: 'Sign in',
    emailMisspellError: 'Did you mean',
    emailRegisteredError: 'This email is already in use.',
    replaceEmailText: 'Replace',
    signInText: 'Sign in',
    resetPasswordText: 'Reset your password',
    autoCompleteEmailPlaceHolder: 'Enter your email',
    autoCompleteEmailLabel: 'Email',
    passwordInputPlaceHolder: 'Create a password',
    passwordInputLabel: 'Password',
    validPasswordText: 'Looks good!',
    passwordValidationMinLength: 'At least 6 characters',
    passwordValidationCaseSensitive: 'Upper / lower case letters',
    passwordValidationSpecialChars: 'Number or punctuation',
    genericError: "It's not you, it’s us. Please try again later.",
    OrText: 'OR',
    readAndAgreeCheckboxLabel: 'I have read and agree to the ',
    termsOfUseLinkText: 'Terms of use',
    andAcknowledgeTheLinkLabel: 'and acknowledge the ',
    privacyPolicyText: 'Privacy Policy',
    cookieNoticeText: 'Cookie Notice',
    promosCheckboxLabel: 'I would like to receive emails from Chegg, its companies, and Chegg’s Brand Partners with special deals, promotions, surveys, and other information. I understand that I can opt out at any time.',
    passwordInputShowText: 'Show',
    passwordInputHideText: 'Hide',
    pxValidationError: 'Oops. Failed to authenticate with Chegg.',
    highschool: 'High School',
    middleschool: 'Middle School',
    college: 'College',
    student: 'Student',
    parent: 'Parent',
    other: 'Other',
    teacher: 'Teacher',
    schoolsDropdownManualInputLabel: 'School name',
    userExistsInMigrationClientError: 'Mathway is now part of Chegg. Please',
    mathwayCredentialsErrorText: 'with your Mathway credentials, or',
    schoolNotListedText: 'For the best study experience, enter your school →',
    schoolNotFoundSelectedValue: 'Enter school below',
    schoolManualInputPlaceholder: 'Ex. University of cali…'
  },
  resetPassword: {
    resetPasswordSubmitButtonTitle: 'Reset password',
    resetPasswordInvalidEmailError: 'Please enter the correct email',
    resetPasswordText: 'Reset password',
    emaillabel: 'Email',
    emailInputPlaceholder: 'Enter your email',
    cancelText: 'Cancel',
    emptyCaptchaErrorText: 'Please check the "I\'m not a robot" box.',
    captchaNotLoadingErrorText: 'Captcha not loading, please try again.',
    emptyEmailError: 'Email can not be empty.',
    termsAgreeText: 'By resetting your password, you agree to the ',
    terms: 'Terms',
    and: 'And',
    privacyPolicy: 'Privacy Policy',
    customerService: 'customer service',
    checkYourEmail: 'Check your email',
    resetPassowrdInstructionsError: 'We’ve sent instructions for resetting your password to',
    gotItText: 'Got it',
    didntGetEmailText: 'Didn’t get email?',
    checkJunkMailText: 'Check your Junk Mail folder or give it some time. If you still don’t have any luck, contact',
    captchaError: 'Security code can not be empty.',
    genericError: "It's not you, it’s us. Please try again later."
  }
};
Object.freeze(defaults);
var $texts = JSON.parse(JSON.stringify(defaults));
export function getTexts() {
  return $texts;
}
export function resetTexts() {
  $texts = JSON.parse(JSON.stringify(defaults));
}